import { render, staticRenderFns } from "./NewDirectoryDialog.vue?vue&type=template&id=4ca3c408"
import script from "./NewDirectoryDialog.vue?vue&type=script&lang=ts"
export * from "./NewDirectoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports